<template>
  <div class="cont" id="cont2">
    <div class="inner">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:31px;width:232px;margin-left:87px;margin-bottom:15px;"
          :src="require('@/assets/image/home/home2/img1.png')"
          :fit="fit">
        </el-image>

        <router-link :to="{ name: 'DJHoldings' }">
          <el-image
            :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
            style="height:18px;width:195px;margin-left:68px;margin-bottom:13px"
            :src="require('@/assets/image/home/home2/img2.png')"
            :fit="fit">
          </el-image>
        </router-link>


                
        <router-link :to="{ name: 'DixcelJp' }">
          <el-image
            :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
            style="height:18px;width:159px;margin-left:55px;margin-bottom:12px"
            :src="require('@/assets/image/home/home2/img3.png')"
            :fit="fit">
          </el-image>
        </router-link>
        <router-link :to="{ name: 'DixcelCn' }">
          <el-image
            :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
            style="height:19px;width:160px;margin-left:41px;margin-bottom:13px"
            :src="require('@/assets/image/home/home2/img4.png')"
            :fit="fit">
          </el-image>
        </router-link>  

        <router-link :to="{ name: 'BrandHistory' }">
          <el-image
            :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
            style="height:17px;width:111px;margin-left:28px;margin-bottom:32px;display:block"
            :src="require('@/assets/image/home/home2/img5.png')"
            :fit="fit">
          </el-image>
        </router-link>    

        <router-link :to="{ name: 'Brand' }">
          <el-image
            :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
            style="height:29px;width:138px;margin-left:0px;margin-bottom:0px;"
            :src="require('@/assets/image/home/home2/img6.png')"
            :fit="fit">
          </el-image>
        </router-link>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContTwo" ,
  data() {
    return {
      fit:  'cover' ,
      animate : false  ,
      screenHeight: window.innerHeight || document.documentElement.clientHeight ,
    }
  } ,
  mounted () {
    // 事件监听滚动条

    window.addEventListener('scroll', this.watchScroll)
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    var topPos = document.getElementById("cont2").offsetTop;
    if( scrollTop + this.screenHeight >  topPos ){
      this.animate = true 
    }

  },
  destroyed(){
    window.removeEventListener('scroll', this.watchScroll);
  },
  methods: {
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var topPos = document.getElementById("cont2").offsetTop;
      if( scrollTop + this.screenHeight >  topPos  ){
        this.animate = true 
      }
    }
  } ,
};
</script>

<style lang="stylus" scoped>

.cont {
  width:1003px;
  height:368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  background: url("~@/assets/image/home/home2/bg.png");
  background-repeat : no-repeat 
  background-size : cover
  position : relative
}
.inner{
  position :absolute;
  width : 319px ;
  height : 217px;
  left : 176px ;
  top : 76px ;
}

</style>